import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	heading: {
		id: 'project-create-importer-upload-flow.third-party-review-screen.heading',
		defaultMessage: 'Review details',
		description: 'Title of third party import review screen',
	},
	backToReview: {
		id: 'project-create-importer-upload-flow.third-party-review-screen.back-to-review',
		defaultMessage: 'Back to review details',
		description: 'Button of back to review',
	},
});
